import React from 'react'
import Flex from 'components/Flex'
import {
  StyledCheckbox,
  StyledGroup,
} from 'components/UIComponents/FilterCheckBoxComp/style'

const FilterCheckBoxComp = ({
  value,
  options,
  onChange,
  valueParam = 'value',
  labelParam = 'label',
  showFromStart,
  valueKey,
}) => {
  

  return (
    <StyledGroup
      value={value}
      onChange={valueKey ? val => onChange(val, valueKey) : onChange}
    >
      {options?.map((item, index) => (
        <Flex spaceBetween centerVertically key={index + item[labelParam]}>
          <StyledCheckbox
            value={item[valueParam]}
            label={item[labelParam]}
            showFromStart={showFromStart}
          />
        </Flex>
      ))}
    </StyledGroup>
  )
}

export default FilterCheckBoxComp
